import { Box, Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Textarea } from '@chakra-ui/react';

import { useAlert } from '@app/hooks';
import { useApi } from '@app/hooks';
import { Txt } from '@app/components/common';
import { useQueryTable } from '@app/components/common/table/query-table';

export const UnCancelModal = ({ isOpen, onClose, outletId }: {
  isOpen: boolean;
  outletId: number;
  onClose: () => void;
}) => {
  const api = useApi();
  const alert = useAlert();
  const { refetch } = useQueryTable();

  const onSubmitClick = async () => {
    try {
      const response = await api.acb.editNewOutlet({ 
        id: Number(outletId), 
        status_id: 1,
      });
      if (response.code === 200) {
        alert.success('Заявка возвращена');
        refetch();
        onClose();
      } else {
        alert.error(response.message);
      }
    } catch (e) {
      console.log(e);

      alert.error('Ошибка при обновлении заявки');
    }
  };

  return (<Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>Возврат отмененной заявки</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Box>
          <Txt>Вы уверены, что хотите возвратить заявку на создание ТТ из отмененного статуса?</Txt>
        </Box>
      </ModalBody>

      <ModalFooter>
        <Flex justify='flex-end' gap={2}>
          <Button onClick={onClose}>Отменить</Button>
          <Button colorScheme='red' onClick={onSubmitClick}>Вернуть</Button>
        </Flex>
      </ModalFooter>
    </ModalContent>
  </Modal>);
};